const GrupoAvaliacaoList = () =>
  import("~/components/Views/Prova/GrupoAvaliacao/List");
const GrupoAvaliacaoNew = () =>
  import("~/components/Views/Prova/GrupoAvaliacao/New");
const GrupoAvaliacaoView = () =>
  import("~/components/Views/Prova/GrupoAvaliacao/View");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Gerenciamento", link: "/prova/gerenciamento" }
];

export const grupoAvaliacao = [
  {
    path: "gerenciamento/grupoAvaliacao",
    component: GrupoAvaliacaoList,
    name: "Grupo de Avaliação",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/grupoAvaliacao/new",
    component: GrupoAvaliacaoNew,
    name: "Novo Grupo de Avaliação",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/grupoAvaliacao/alunos/:id",
    component: GrupoAvaliacaoView,
    name: "Visualizar Notas dos Alunos",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/grupoAvaliacao/:id",
    component: GrupoAvaliacaoNew,
    name: "Alterar Grupo de Avaliação",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/grupoAvaliacao.js